module.exports = __webpack_public_path__ + "static/media/noneData.47b61b14.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/noneData.png
// module id = 1405
// module chunks = 10